import { MASTERDATA_BASE_URL, MasterDataCall } from "./helper";

export const masterDataApi = async (masterDataType) => {
    try {
        const data = await MasterDataCall(`${MASTERDATA_BASE_URL}`, {
            method: "POST",
            data: { dataType: masterDataType },
        });

        if (data?.statusCode !== 200)
            throw new Error('Error while fetching master data')
        return data;
    } catch (error) {
        console.error("master data API Error:", error.message);
        throw error;
    }
};

